import React, { FC, useEffect, useContext } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Button, Paper } from '@material-ui/core';
import HeroSection from './Sections/Hero';
import VenziWheelSection from './Sections/VenziWheel';
import gsap from 'gsap';
import { NavigatorWheelContext } from '../../Contexts/NavigatorWheelContext';
import { HOME_SCREEN_ROOT_ID, APP_HEADER_HEIGHT } from '../../Constants';
import Testimonial from './Sections/Testimonial';
import Experiences from './Sections/Experiences';
import withMountAnimation, { WithMountAnimation } from '../withMountAnimation';
import HorizontalList from '../../Components/HorizontalList';
import useHorizontalList from '../../Components/HorizontalList/useHorizontalList';
import MetaTag from '../../Components/MetaTag';
import { useMediaQuery } from '../../Hooks/useMediaQuery';

export interface HomeScreenProps extends WithMountAnimation {

}

const HomeScreen: FC<HomeScreenProps> = (props) => {
    const classes = useStyles();
    const { curSection, setCurSection } = useContext(NavigatorWheelContext);
    const { isDeviceSm } = useMediaQuery();

    useEffect(() => {
        const el = document.getElementById(HOME_SCREEN_ROOT_ID);

        gsap.to(window, {
            scrollTo: {
                y: 0,
                offsetY: APP_HEADER_HEIGHT,
            },
            duration: 0.5,
            ease: "power2.easeOut"
        })
        return () => {
            if (el)
                el.scrollTo({ top: 0 });
        }
    }, [])

    return (
        <Box id={HOME_SCREEN_ROOT_ID} className={classes.root}>
            <MetaTag title='Home' />
            <Box width={isDeviceSm ? '100vw' : '800px'} mx='auto' pt={12}>
                <HeroSection />
            </Box>
            <Box maxWidth={EXPERIENCES_CONTAINER_WIDTH + 'px'} mx='auto' px={isDeviceSm ? 3 : 10}>
                <Experiences />
            </Box>

            <Box width='100%' mx='auto' my={5} py={12}>
                <Testimonial />
            </Box>
            <Box width={isDeviceSm ? '100vw' : '800px'} id="trigger-home-disc" mx='auto' pt={12}>
                <VenziWheelSection />
            </Box>
        </Box>
    )
}

export const EXPERIENCES_CONTAINER_WIDTH = 1400

const useStyles = makeStyles<Theme, any>((theme) => ({
    root: {
        // background: GRADIENTS[0],
        minHeight: '100vh',
    },
}));

export default withMountAnimation(HomeScreen);